import omitBy from 'lodash-es/omitBy'
import cloneDeep from 'lodash-es/cloneDeep'

// Remove undefined values from an object deeply
export default function compactObject(obj: any) {
  return cloneDeep(omitBy(obj, value => {
    if (typeof value === 'object' && value !== null) {
      return compactObject(value)
    }
    return typeof value === 'undefined'
  }))
}
